import React from 'react';
import { Label } from '@/components/ui/label';

interface QuestionDisplayProps {
  question?: string | string[] | null;
  context?: string;
  contextUrl?: string;
}

const QuestionDisplay: React.FC<QuestionDisplayProps> = ({
  question,
  context,
  contextUrl
}) => {
  // Process the question text
  let questionText = '';
  
  if (Array.isArray(question)) {
    questionText = question.join(' ');
  } else if (typeof question === 'string') {
    questionText = question.trim();
  } else if (question) {
    questionText = String(question).trim();
  }
  
  if (!questionText) {
    return null;
  }
  
  return (
    <div className="space-y-2">
      <Label htmlFor="question" className="text-sm font-medium leading-none">
        Spørsmål til deg:
      </Label>
      <div
        id="question"
        className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {questionText}
      </div>
      
      {context && (
        <div className="space-y-2">
          <Label className="text-sm font-medium leading-none">Kontekst (valgfritt)</Label>
          <div className="flex min-h-[60px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50">
            {context}
          </div>
        </div>
      )}
      
      {contextUrl && (
        <button
          onClick={() => window.open(contextUrl, '_blank')}
          className="mt-3 text-blue-600 hover:text-blue-800 underline text-sm"
          type="button"
        >
          Se kontekst
        </button>
      )}
    </div>
  );
};

export default QuestionDisplay;